import { actionCreators as contentActionCreators } from "Areas/Documents/content";
import { getInnerObjectsSelectedIds } from "Areas/Documents/documentDetails";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getActiveDocumentId, getActiveDocumentType, getFilteredNavigationObjects, getObjects, getObjectsInProgress } from "../redux/selectors";
import TabNavigation from "./tabNavigation";
const mapStateToProps = (state) => ({
    documentType: getActiveDocumentType(state),
    inProgress: getObjectsInProgress(state),
    navigationObjects: getFilteredNavigationObjects(state),
    documentObjects: getObjects(state),
    selectedIds: getInnerObjectsSelectedIds(state),
    activeDocumentId: getActiveDocumentId(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(actionCreators.getObjects()),
    onNavigateTo: (id) => dispatch(actionCreators.setNavigateTo(id)),
    onLoadContentChildren: (documentId, nodeId) => {
        dispatch(contentActionCreators.getContentChildren(documentId, nodeId));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(TabNavigation);
